/**
 * @generated SignedSource<<5f2ffa5f01425cac2749d69cfd31ba98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTile_nftItem$data = {
  readonly linkData: {
    readonly isLinkable: boolean | null;
    readonly path: string | null;
  };
  readonly wasBurned: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_nftItem" | "ItemInternalContext_nftItem" | "NftItemTileContent_nftItem" | "NftItemTileMedia_item">;
  readonly " $fragmentType": "NftItemTile_nftItem";
};
export type NftItemTile_nftItem$key = {
  readonly " $data"?: NftItemTile_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTile_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasBurned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileMedia_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeartPill_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemInternalContext_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "060d8b30de82b61ddf0a755431115199";

export default node;
